import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/api/client";
import { toast } from "sonner";

export default function ContactForm({ leadType = "contacto", zone = "", propertySlug = null, compact = false, testidPrefix = "contact" }) {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const onChange = (e) => setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.post("/leads", {
        ...form,
        lead_type: leadType,
        zone,
        property_slug: propertySlug,
      });
      setForm({ name: "", email: "", phone: "", message: "" });
      navigate(`/obrigado?type=${leadType}`);
    } catch (err) {
      toast.error(formatApiErrorDetail(err?.response?.data?.detail) || "Não foi possível enviar. Tente novamente.");
      setSubmitting(false);
    }
  };

  return (
    <form onSubmit={onSubmit} data-testid={`${testidPrefix}-form`} className="space-y-4">
      <div className={`grid gap-4 ${compact ? "" : "md:grid-cols-2"}`}>
        <div>
          <label className="block text-xs uppercase tracking-widest text-stone-500 mb-2">Nome</label>
          <input
            required
            name="name"
            value={form.name}
            onChange={onChange}
            data-testid={`${testidPrefix}-input-name`}
            className="w-full rounded-lg border border-stone-200 bg-white px-4 py-3 text-sm text-stone-900 focus:outline-none focus:ring-2 focus:ring-[#103C4A]/30"
            placeholder="O seu nome"
          />
        </div>
        <div>
          <label className="block text-xs uppercase tracking-widest text-stone-500 mb-2">Email</label>
          <input
            required
            type="email"
            name="email"
            value={form.email}
            onChange={onChange}
            data-testid={`${testidPrefix}-input-email`}
            className="w-full rounded-lg border border-stone-200 bg-white px-4 py-3 text-sm text-stone-900 focus:outline-none focus:ring-2 focus:ring-[#103C4A]/30"
            placeholder="voce@exemplo.com"
          />
        </div>
      </div>
      <div>
        <label className="block text-xs uppercase tracking-widest text-stone-500 mb-2">Telefone</label>
        <input
          name="phone"
          value={form.phone}
          onChange={onChange}
          data-testid={`${testidPrefix}-input-phone`}
          className="w-full rounded-lg border border-stone-200 bg-white px-4 py-3 text-sm text-stone-900 focus:outline-none focus:ring-2 focus:ring-[#103C4A]/30"
          placeholder="+351"
        />
      </div>
      <div>
        <label className="block text-xs uppercase tracking-widest text-stone-500 mb-2">Mensagem</label>
        <textarea
          name="message"
          rows={4}
          value={form.message}
          onChange={onChange}
          data-testid={`${testidPrefix}-input-message`}
          className="w-full rounded-lg border border-stone-200 bg-white px-4 py-3 text-sm text-stone-900 focus:outline-none focus:ring-2 focus:ring-[#103C4A]/30"
          placeholder="Diga-nos como podemos ajudar..."
        />
      </div>
      <button
        type="submit"
        disabled={submitting}
        data-testid={`${testidPrefix}-submit`}
        className="btn-primary w-full sm:w-auto"
      >
        {submitting ? "A enviar..." : "Enviar mensagem"}
      </button>
    </form>
  );
}
